import axios from 'axios'

export default {
    getUnread(query, fields) {
        const _fields = (
            fields || [
                'id',
                'objectId',
                'body',
                'toUser(id,designation,firstName,lastName,userRole(id,name),avatar(thumb-360,source))',
                'fromUser(id,designation,firstName,lastName,userRole(id,name))',
                'createdDateTime',
                'properties(referralFromUserId,referralToUserId)',
                'fromPractice(id,name,practiceType,email)',
                'toPractice(id,name,practiceType,email)',
            ]
        ).join(',')

        const params = {
            _fields,
            ...query,
        }
        return axios.get('messages/unread', { params })
    },
    sendMessage(query) {
        return axios.post('messages', query)
    },
    getMessages(query, fields) {
        const _fields = (
            fields || [
                'id',
                'objectId',
                'body',
                'toUser(id,designation,firstName,lastName,userRole(id,name),avatar(thumb-360,source))',
                'fromUser(id,designation,firstName,lastName,userRole(id,name))',
                'createdDateTime',
                'attachments(fileName,note,url,extension)',
                'fromPractice(id,name,practiceType,email)',
                'toPractice(id,name,practiceType,email)',
            ]
        ).join(',')

        const params = {
            _fields,
            ...query,
        }
        return axios.get('messages/', { params })
    },
    markSeen(query) {
        return axios.post('messages/mark-seen/', query)
    },
}
